// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e253d81b","453":"8732f6c5","455":"a5af9a17","977":"dc5107c9"}[chunkId] + ".chunk.js";
};